import React, { Component } from "react";
import { connect } from "react-redux";
import LayoutWrap from "../Component/LayoutWrap";
import { dashboardActions } from "../../../_actions";

import ViewChapters from "./Components/ViewChapters";

import { LuArrowLeft, LuX } from 'react-icons/lu';
import { MdOutlineArrowForwardIos, MdOutlineArrowBackIos } from "react-icons/md";
import { FiEdit, FiSave } from "react-icons/fi";
import { FaPlus } from "react-icons/fa6";

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';


class ReadingCaseStudy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeChapter: 0,
      crrCaseStudyId: this.props.match.params.id,
      openAddNewModal: false,

      chapterForm: {
        chapterName: "",
        paragraphs: [
          {
            paraTitle: "",
            paraSubtitle: "",
            paraDesc: ""
          }
        ]
      }
    };
  }

  componentDidMount() {
    let data = {
      caseStudyId: this.state.crrCaseStudyId,
      keyWord: "",
      pageNo: 1,
      size: 10
    };
    this.props.dispatch(dashboardActions.getCaseStudyDetailsList(data));
  }

  setChapter = (index) => {
    this.setState({ activeChapter: index, openAddNewModal: false });
  };

  nextChapter = () => {
    let { dashboard } = this.props;
    let { getCaseStudyDetailsListData = [] } = dashboard;

    if (this.state.activeChapter < getCaseStudyDetailsListData.length - 1) {
      this.setState({ activeChapter: this.state.activeChapter + 1 });
    }
  };

  prevChapter = () => {
    if (this.state.activeChapter > 0) {
      this.setState({ activeChapter: this.state.activeChapter - 1 });
    }
  };

  addNewChapter = () => {
    this.setState({
      openAddNewModal: true,
      chapterForm: {
        chapterName: "",
        paragraphs: [
          { paraTitle: "", paraSubtitle: "", paraDesc: "" }
        ]
      }
    });
  };

  handleChapterName = (e) => {
    const { chapterForm } = this.state;

    this.setState({
      chapterForm: {
        ...chapterForm,
        chapterName: e.target.value
      }
    });
  };
  handleParagraphChange = (index, field, value) => {
    let { chapterForm } = this.state;

    let paragraphs = [...chapterForm.paragraphs];
    paragraphs[index][field] = value;

    this.setState({
      chapterForm: {
        ...chapterForm,
        paragraphs
      }
    });
  };
  addParagraph = () => {
    let { chapterForm } = this.state;

    this.setState({
      chapterForm: {
        ...chapterForm,
        paragraphs: [
          ...chapterForm.paragraphs,
          { paraTitle: "", paraSubtitle: "", paraDesc: "" }
        ]
      }
    });
  };
  discardChapter = () => {
    this.setState({
      openAddNewModal: false,
      chapterForm: {
        chapterName: "",
        paragraphs: [
          { paraTitle: "", paraSubtitle: "", paraDesc: "" }
        ]
      }
    });
  }

  saveChapter = () => {
    const { chapterForm, crrCaseStudyId } = this.state;
    let { dashboard } = this.props;
    let { getCaseStudyDetailsListTotal } = dashboard;

    let data = {
      caseStudyId: crrCaseStudyId,
      chapterName: chapterForm.chapterName,
      chapterNo: getCaseStudyDetailsListTotal > 0 ? getCaseStudyDetailsListTotal + 1 : 0,
      paragraphs: chapterForm.paragraphs
    };

    console.log("data", data);

    let temp = {
      caseStudyId: crrCaseStudyId,
      keyWord: "",
      pageNo: 1,
      size: 10
    };
    this.props.dispatch(dashboardActions.saveCaseStudyDetails(data, temp));
    this.setState({
      openAddNewModal: false,
      chapterForm: {
        chapterName: "",
        paragraphs: [
          { paraTitle: "", paraSubtitle: "", paraDesc: "" }
        ]
      }
    });
  };

  saveEditDetails = (details) => {
    console.log("details-------------->", details)

    const { crrCaseStudyId } = this.state;
    let data = {
      caseStudyId: crrCaseStudyId,
      chapterId: details.chapterId,
      chapterName: details.chapterName,
      paragraphs: details.paragraphs
    };
    console.log("Update-------------->", data)
    let temp = {
      caseStudyId: crrCaseStudyId,
      keyWord: "",
      pageNo: 1,
      size: 10
    };
    this.props.dispatch(dashboardActions.updateCaseStudyDetails(data, temp));
  }

  goToBack = () => {
    this.props.history.push("/insightadmin/casestudy");
  }
  render() {
    let { activeChapter, openAddNewModal, chapterForm } = this.state;
    let { dashboard } = this.props;
    let { getCaseStudyDetailsListData = [], getCaseStudyDetailsListTotal, getCaseStudyDetailMainData } = dashboard;


    let currentChapter = getCaseStudyDetailsListData[activeChapter];

    // console.log("getCaseStudyDetailMainData----////---->", getCaseStudyDetailMainData)

    return (
      <LayoutWrap>
        <div className="w-full mx-auto p-4 md:p-6 text-[#212121]">

          <div className="flex items-center gap-4 mb-8 pb-4 border-b border-gray-300">
            <button onClick={() => this.goToBack()} className="p-2 rounded-full bg-indigo-100 text-indigo-600">
              <LuArrowLeft size={24} />
            </button>
            <h1 className="md:text-2xl text-xl font-medium textblack">{getCaseStudyDetailMainData && getCaseStudyDetailMainData.name ? getCaseStudyDetailMainData.name : "Case Study Details"}</h1>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
            {/* Sidebar Navigation */}
            <div className="lg:col-span-4 h-screen pb-52 overflow-y-auto scrollbar">
              <div className="sticky top-6 overflow-y-auto border border-gray-300 rounded-xl scrollbar">
                {getCaseStudyDetailsListData && getCaseStudyDetailsListData.length > 0 &&
                  getCaseStudyDetailsListData.map((item, index) => (
                    <button
                      key={item.id}
                      onClick={() => this.setChapter(index)}
                      className={`w-full text-left px-6 py-3 transition-all border-b border-gray-300 last:border-b-0 flex flex-col ${activeChapter === index
                        ? 'bg-indigo-100 border-r-4 border-r-[#5B21B6]'
                        : 'hover:bg-gray-50'
                        }`}
                    >
                      <span className={`font-medium text-lg ${activeChapter === index ? 'text-[#212121]' : 'textblack'}`}>{item.chapterName}</span>
                      <span className="text-indigo-600 text-sm font-medium capitalize mt-1">
                        Chapter {index + 1}</span>
                    </button>
                  ))}
                <div onClick={() => this.addNewChapter()} className="w-full text-left px-6 py-5 bg-indigo-100 transition-all hover:bg-gray-50">
                  <p className="flex items-center text-indigo-600 text-lg font-medium capitalize gap-4">
                    <FaPlus size={22} />
                    <span>Add New Chapter</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="lg:col-span-8 pr-2 h-screen pb-52 overflow-y-auto scrollbar">
              {/* Content Area */}
              {openAddNewModal ?
                <>
                  <div className="lg:col-span-8">
                    <div className="flex items-center justify-between pb-4 border-b border-gray-300 mb-8">
                      <div ></div>
                      <div className="flex items-center gap-4">
                        <button
                          onClick={this.discardChapter}
                          className="flex items-center gap-4 px-5 py-2 border border-gray-300 text-lg font-medium text-indigo-600 rounded-md"
                        >
                          <LuX />
                          Discard
                        </button>
                        <button
                          onClick={this.saveChapter}
                          className="flex items-center gap-4 px-5 py-2 border border-gray-300 text-lg font-medium text-indigo-600 rounded-md"
                        >
                          <FiSave />
                          Save
                        </button>
                      </div>
                    </div>
                    {/* CaseStudy Add Section */}
                    <div className="lg:col-span-8">
                      <header className="mb-8">
                        <h2 className="text-3xl font-semibold mb-2">Add New Chapter</h2>
                      </header>

                      <div className="space-y-4 mb-8">
                        <input type="text" value={this.state.chapterForm.chapterName}
                          onChange={this.handleChapterName} placeholder="Chapter Name" className="w-full border border-gray-300 rounded-md px-4 py-3 outline-none placeholder:text-gray-300 textblack" />
                        <input type="text" placeholder="Chapter" className="w-full border border-gray-300 rounded-md px-4 py-3 outline-none placeholder:text-gray-300 textblack" />
                      </div>
                      {this.state.chapterForm.paragraphs.map((para, index) => (

                        <div className="border border-gray-300 rounded-lg p-6 space-y-4 mb-6">
                          <h3 className="font-semibold text-[#212121]">Paragraph {index + 1}</h3>
                          <input type="text" value={para.paraTitle}
                            onChange={(e) =>
                              this.handleParagraphChange(
                                index,
                                "paraTitle",
                                e.target.value
                              )
                            } placeholder="About Organization" className="w-full border border-gray-300 rounded-md px-4 py-3 outline-none placeholder:text-gray-300 textblack" />
                          <input type="text" value={para.paraSubtitle}
                            onChange={(e) =>
                              this.handleParagraphChange(
                                index,
                                "paraSubtitle",
                                e.target.value
                              )
                            } placeholder="The company headquarters are located in Farmington, Connecticut." className="w-full border border-gray-300 rounded-md px-4 py-3 outline-none placeholder:text-gray-300 textblack" />
                          <div className="border border-gray-300 rounded-md overflow-hidden">
                            <ReactQuill
                              theme="snow"
                              value={para.paraDesc}
                              onChange={(value) =>
                                this.handleParagraphChange(
                                  index,
                                  "paraDesc",
                                  value
                                )
                              }
                              className="custom-quill"
                            />
                          </div>
                        </div>
                      ))}
                      <div className="w-full text-left px-6 py-3 bg-indigo-100 transition-all hover:bg-gray-50 rounded-lg border border-gray-300">
                        <p onClick={this.addParagraph} className="flex items-center justify-center text-indigo-600 text-lg font-medium capitalize gap-4">
                          <FaPlus size={22} />
                          <span>Add New Paragraph</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </>
                :
                <ViewChapters
                  currentChapter={currentChapter}
                  prevChapter={this.prevChapter}
                  nextChapter={this.nextChapter}
                  onSave={this.saveEditDetails}
                />}
            </div>

          </div>
        </div>
      </LayoutWrap>
    );
  }
}

const mapStateToProps = (state) => ({
  loggingIn: state.authentication?.loggingIn,
  dashboard: state.dashboard,
});

export default connect(mapStateToProps)(ReadingCaseStudy);